import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            关于吃瓜在线的常见疑问解答，帮助你更好地使用平台观看吃瓜视频
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden"
              open={idx === 0}
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full bg-background-200 group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-sm text-foreground-600 group-open:text-primary-600 transition-transform group-open:rotate-180"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}